
import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './ailaw.json';

const Ailaw = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Legal and ethical English for AI regulation, copyright, and technology law. B2/C1 level grammar, reading, and discussion exercises."
            level="B2"
            title="AI Law"
            image="/Images/ailaw.webp"
            seoTitle="Free English Lesson Plans: AI and Work"
            seoDescription="Legal and ethical English for AI regulation, copyright, and technology law. B2/C1 level grammar, reading, and discussion exercises."
        >
                       
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Ailaw;


